//
//
//
//

import { mapGetters, mapActions } from 'vuex'

const POLL_INTERVAL_MS = 5000

export default {
  name: 'ReportStatusWatcher',
  data () {
    return {
      pollTimer: null,
      jobStatusById: {}
    }
  },
  computed: {
    ...mapGetters({
      reportJobs: 'reports/getReportJobs',
      hasPendingReportJobs: 'reports/hasPendingReportJobs'
    })
  },
  watch: {
    hasPendingReportJobs (pending) {
      if (pending) {
        this.startPolling()
      } else {
        this.stopPolling()
      }
    },
    reportJobs (jobs) {
      this.notifyOnTransitions(jobs || [])
    }
  },
  async mounted () {
    await this.fetchReportJobs()
    this.jobStatusById = (this.reportJobs || []).reduce((acc, j) => {
      acc[j._id] = j.status
      return acc
    }, {})
    if (this.hasPendingReportJobs) {
      this.startPolling()
    }
  },
  beforeDestroy () {
    this.stopPolling()
  },
  methods: {
    ...mapActions({
      fetchReportJobs: 'reports/fetchReportJobs'
    }),
    startPolling () {
      if (this.pollTimer) { return }
      this.pollTimer = setInterval(() => {
        this.fetchReportJobs()
      }, POLL_INTERVAL_MS)
    },
    stopPolling () {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    notifyOnTransitions (jobs) {
      const next = {}
      for (const job of jobs) {
        next[job._id] = job.status
        const prev = this.jobStatusById[job._id]
        if (prev === 'pending' && job.status === 'done') {
          const h = this.$createElement
          const body = h('div', [
            h('div', { class: 'mb-1' }, `"${job.reportTitle || 'Report'}" is ready.`),
            h('a', {
              attrs: { href: job.pdfUrl, target: '_blank', rel: 'noopener' }
            }, 'Open PDF')
          ])
          this.$bvToast.toast(body, {
            title: 'Your Report is Ready',
            variant: 'success',
            toaster: 'b-toaster-top-right',
            solid: true,
            noAutoHide: true
          })
        } else if (prev === 'pending' && job.status === 'failed') {
          this.$bvToast.toast(job.error || 'Report generation failed.', {
            title: 'Report Failed',
            variant: 'danger',
            toaster: 'b-toaster-top-right',
            solid: true
          })
        }
      }
      this.jobStatusById = next
    }
  }
}
